import { useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { getBusinessArticle } from "@/data/businessArticles";
import "@/styles/research-article.css";

const BusinessArticle = () => {
  const { slug = "" } = useParams();
  const article = getBusinessArticle(slug);

  useEffect(() => {
    if (!article) return;
    const previousTitle = document.title;
    const previousDescription = document.querySelector('meta[name="description"]')?.getAttribute("content") ?? null;
    document.title = article.seoTitle ?? `${article.title} | WMT AI`;
    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement("meta");
      description.setAttribute("name", "description");
      document.head.appendChild(description);
    }
    description.setAttribute("content", article.seoDescription ?? article.description);
    return () => {
      document.title = previousTitle;
      if (previousDescription === null) description?.remove();
      else description?.setAttribute("content", previousDescription);
    };
  }, [article]);

  if (!article) return null;

  return (
    <div className="min-h-screen bg-[#f3f4f6] text-foreground">
      <Navbar />
      <main className="px-4 pb-24 pt-28 sm:px-6 lg:pb-32 lg:pt-32">
        <div className="mx-auto max-w-5xl">
          <article>
            <div className="border-b border-border/60 pb-10">
              <h1 className="font-heading text-4xl font-medium leading-[1.08] sm:text-5xl lg:text-[56px]">{article.title}</h1>
              <p className="mt-5 max-w-3xl text-lg leading-relaxed text-muted-foreground">{article.description}</p>
            </div>

            <div className="research-article mt-12 max-w-3xl">
              <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ h1: () => null }}>
                {article.markdown}
              </ReactMarkdown>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BusinessArticle;
